import axios from 'axios'

import { getApiUrl } from '#/shared/lib/constants'

export const api = axios.create({
	validateStatus: () => true,
	baseURL: process.env.NEXT_PUBLIC_API_HOST ?? '',
})

api.interceptors.request.use((config) => {
	const baseURL = getApiUrl()
	config.baseURL = baseURL || process.env.NEXT_PUBLIC_API_HOST || ''
	return config
})

api.interceptors.response.use(
	(response) => response,
	(error) => {
		return error
	}
)
